import React from 'react'

import Spinner from '~/components/loader/Spinner'
import SearchStatus from './SearchStatus'

const TicketLoader = ({fetcher}) => {
  return ( <>
    <div>
      <Spinner isMobile />
    </div>
    <SearchStatus fetcher={fetcher} />
    </>
  )
}

export default TicketLoader
